export default "__VITE_ASSET__Cp8fSPm7__"